import Vue from 'vue'

export const ProcessMessage = {
    install(Vue, options) {
        Vue.prototype.$process = (data) => {
            if((data instanceof Object) && (data.hasOwnProperty('cod')) && (data.hasOwnProperty('message')) && (data.hasOwnProperty('type'))){
                return data;
            }else throw 'ProcessMessage - Plugin Error: The data must be an object type';
        }
    }
};

// After this first part of system, we'll need to implement a translation to messages. For now, I just return the data, but after I'll return the data with trataments (like translate message)